import { getTokenTime, getRefreshToken } from '@/utils/storage'
import store from '@/store'

const MAX_REFRESH_TOKEN_CD = 20 * 60  // 20 minutes
const MAX_INACTIVE_CD = 30 * 60        // 30 minutes
const CHECK_INTERVAL = 1000             // check every second
const ACTIVITY_THROTTLE_MS = 5000       // throttle activity reset to every 5s

let inactiveTimer = null
let refreshTimer = null
let inactiveCountdown = MAX_INACTIVE_CD
let lastActivityReset = 0

function resetInactiveCountdown() {
  const now = Date.now()
  if (now - lastActivityReset < ACTIVITY_THROTTLE_MS) return
  lastActivityReset = now
  inactiveCountdown = MAX_INACTIVE_CD
  store.commit('timer/SET_INACTIVE_COUNTDOWN', inactiveCountdown)
}

function handleActivity() {
  resetInactiveCountdown()
}

export default {
  namespaced: true,
  state: {
    inactiveCountdown: MAX_INACTIVE_CD
  },
  mutations: {
    SET_INACTIVE_COUNTDOWN(state, val) {
      state.inactiveCountdown = val
    },
    RESET_INACTIVE_COUNTDOWN(state) {
      state.inactiveCountdown = MAX_INACTIVE_CD
    }
  },
  actions: {
    startTimers({ commit, dispatch, rootState, rootGetters }) {
      // Stop any existing timers first
      dispatch('stopTimers')

      // Inactivity timer
      inactiveTimer = setInterval(() => {
        inactiveCountdown--
        if (inactiveCountdown <= 0) {
          dispatch('auth/logout', null, { root: true })
          return
        }
        commit('SET_INACTIVE_COUNTDOWN', inactiveCountdown)
      }, CHECK_INTERVAL)

      // Token refresh timer
      refreshTimer = setInterval(() => {
        const tokenTime = getTokenTime()
        if (!tokenTime) return
        const elapsed = (new Date().getTime() - parseInt(tokenTime)) / 1000
        if (elapsed >= MAX_REFRESH_TOKEN_CD) {
          const rt = getRefreshToken()
          if (rt) {
            // Token refresh — do NOT reset inactive countdown.
            // Inactivity-based logout (30 min) should fire regardless of token validity.
            dispatch('auth/refreshToken', null, { root: true })
          }
        }
      }, 60000) // check every 60 seconds

      // Listen for user activity
      document.addEventListener('mousemove', handleActivity)
      document.addEventListener('keydown', handleActivity)

      // Reset countdown on start
      resetInactiveCountdown()
      commit('SET_INACTIVE_COUNTDOWN', inactiveCountdown)
    },
    stopTimers({ commit }) {
      // Clear timers first — before modifying countdown
      if (inactiveTimer) {
        clearInterval(inactiveTimer)
        inactiveTimer = null
      }
      if (refreshTimer) {
        clearInterval(refreshTimer)
        refreshTimer = null
      }
      document.removeEventListener('mousemove', handleActivity)
      document.removeEventListener('keydown', handleActivity)

      // 2. Only reset countdown if timers are truly being stopped for logout/navigation
      //    (not called internally by startTimers which dispatches stopTimers first)
      commit('SET_INACTIVE_COUNTDOWN', MAX_INACTIVE_CD)
      inactiveCountdown = MAX_INACTIVE_CD
    },
    resetInactiveTimer() {
      resetInactiveCountdown()
    }
  }
}
